"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StunningGuatapeOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="stunning-guatapé-overview" className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden bg-background">
      {}
      <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/guatape_sunrise_poster.png">
        <source src="https://cdn.pixabay.com/video/2020/05/25/40131-424917409_large.mp4" type="video/mp4" />
      </video>

      {}
      <div className="absolute inset-0 opacity-[0.15] mix-blend-overlay pointer-events-none" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} />

      {}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent pointer-events-none" />

      {}
      <div ref={ref} className={`relative z-10 flex flex-col items-center text-center px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <span className="font-mono uppercase tracking-widest text-primary-foreground/80 mb-6 text-sm md:text-base font-medium">
          Discover the Jewel of Antioquia
        </span>
        
        <h1 className="font-default text-secondary font-light text-5xl md:text-7xl lg:text-8xl leading-tight mb-10 max-w-5xl drop-shadow-lg">
          Awaken to the Abyss
        </h1>
        
        <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-700 ease-in-out shadow-lg shadow-primary/20 hover:shadow-primary/40 hover:-translate-y-1 px-10 py-6 text-lg">
          <Link to="/GuatapePage">Experience Guatapé</Link>
        </Button>
      </div>
    </section>;
}